import React from "react"
import styled from "@emotion/styled"
import PropTypes from "prop-types"
import NextReadersLatestImage from "./images/next-readers-latest-image"
import ReaderBlockBgImage from "./images/reader-block-bg-image"
import facepaint from "facepaint"
import parse from "html-react-parser"
import moment from "moment-timezone/builds/moment-timezone-with-data"

const TIME_ZONE = "Asia/Tokyo"
moment.tz.setDefault(TIME_ZONE)

const breakpoints = [576, 768, 992, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const ReaderBlock = ({
  post_title,
  name,
  photo,
  title,
  layout,
  bg,
  anchor_link,
  post_url,
  publish_date,
}) => {
  const FIRST_PUBLISH_DATE = "2020/1/4 15:00:00"
  const moment_first_publish_date = moment(
    FIRST_PUBLISH_DATE,
    "YYYY/M/D HH:mm:ss"
  )
  const moment_publish_date = moment(publish_date, "YYYY/M/D HH:mm:ss")
  const moment_now = moment()
  const publish_date_txt = moment_publish_date.format("M月D日")

  let isPublish = false
  if (moment_publish_date.isSameOrBefore(moment_now)) {
    isPublish = true
  } else if (moment_publish_date.isSameOrBefore(moment_first_publish_date)) {
    isPublish = true
  }

  const Container = styled.div`
    color: #ffffff;
    width: 100%;
    position: relative;
    ${mq({
      paddingTop: ["8.0vw", "140px", "140px", "140px"],
    })}
  `
  const FlexBox = styled.div`
    display: flex;
    max-width: 1000px;
    margin: 0 auto;
    ${mq({
      padding: [
        "0 4.5vw 12.0vw",
        "0 70px 150px",
        "0 70px 150px",
        "0 70px 150px",
      ],
    })};
  `

  const FlexBox1 = styled.div`
    order: ${layout === "left" ? 1 : 2};
    flex-basis: 57%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `
  const FlexBox2 = styled.div`
    text-align: ${layout};
    order: ${layout === "right" ? 1 : 2};
    flex-basis: 43%;
    padding: 0;
    padding-left: ${layout === "left" ? "4.0vw" : 0};
    padding-right: ${layout === "right" ? "4.0vw" : 0};
    display: flex;
    flex-direction: column;
    justify-content: center;
  `

  const PostTitle = styled.div`
    line-height: 1.4;
    ${mq({
      fontSize: ["2.85vw", "1.125rem", "1.125rem", "1.125rem"],
    })}
  `

  const Name = styled.div`
    ${mq({
      fontSize: ["3.8vw", "1.75rem", "1.75rem", "1.75rem"],
      marginTop: ["2.6vw", "18px", "18px", "18px"],
      marginBottom: ["1.2vw", "10px", "10px", "10px"],
    })}
  `
  const Title = styled.div`
    ${mq({
      fontSize: ["1.8vw", "0.75rem", "0.75rem", "0.75rem"],
    })}
  `

  const Interview = styled.div`
    ${mq({
      marginTop: ["2.6vw", "18px", "18px", "18px"],
    })}
  `
  const LinkedNextReadersLatestImage = styled.a``
  const InterviewButton = styled.a`
    position: relative;
    display: inline-block;
    background-color: #c7a542;
    font-weight: bold;
    text-decoration: none;
    color: #ffffff;
    line-height: 1.2;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    -o-transition: all 0.5s ease;
    transition: all 0.5s ease;

    ::after {
      position: relative;
      content: "▶";
      padding: 0;
      line-height: 1;
      ${mq({
        top: ["-0.10vw", "-0.05rem", "-0.05rem", "-0.05rem"],
        fontSize: ["0.625rem", "0.625rem", "0.625rem", "0.625rem"],
        paddingLeft: ["0.5vw", "0.25rem", "0.25rem", "0.25rem"],
      })}
    }
    :hover {
      background-color: #ffffff;
      color: #c7a542;
    }
    ${mq({
      fontSize: ["2.4vw", "0.875rem", "0.875rem", "0.875rem"],
      padding: ["1.0vw 2.0vw", "6px 12px", "6px 12px", "6px 12px"],
      borderRadius: ["0.65vw", "3.2px", "3.2px", "3.2px"],
    })}
  `
  const YoteiInterviewButton = styled.span`
    position: relative;
    display: inline-block;
    background-color: #c7a542;
    font-weight: bold;
    text-decoration: none;
    color: #ffffff;
    line-height: 1.2;
    ${mq({
      fontSize: ["2.4vw", "0.875rem", "0.875rem", "0.875rem"],
      padding: ["1.0vw 2.0vw", "6px 12px", "6px 12px", "6px 12px"],
      borderRadius: ["0.65vw", "3.2px", "3.2px", "3.2px"],
    })}
  `

  const BackgroundImageContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `
  const BackgroundImageContainerInner = styled.div`
    max-width: 1000px;
    opacity: 0.2;
    display: flex;
    justify-content: ${layout === "left" ? "flex-start" : "flex-end"};
    margin: 0 auto;

    picture img {
      height: 100%;
      object-position: 5%;
    }
  `
  return (
    <Container id={anchor_link}>
      <BackgroundImageContainer>
        <BackgroundImageContainerInner>
          <ReaderBlockBgImage fileName={bg}></ReaderBlockBgImage>
        </BackgroundImageContainerInner>
      </BackgroundImageContainer>

      <FlexBox>
        <FlexBox1 layout={layout}>
          {isPublish && (
            <LinkedNextReadersLatestImage href={post_url} target="_blank">
              <NextReadersLatestImage fileName={photo}></NextReadersLatestImage>
            </LinkedNextReadersLatestImage>
          )}
          {!isPublish && (
            <NextReadersLatestImage fileName={photo}></NextReadersLatestImage>
          )}
        </FlexBox1>
        <FlexBox2 layout={layout}>
          <PostTitle>{parse(post_title)}</PostTitle>
          <Name>{parse(name)}</Name>
          <Title>{parse(title)}</Title>
          <Interview>
            {isPublish && (
              <InterviewButton href={post_url} target="_blank">
                INTERVIEW
              </InterviewButton>
            )}
            {!isPublish && (
              <YoteiInterviewButton>
                {publish_date_txt}公開予定
              </YoteiInterviewButton>
            )}
          </Interview>
        </FlexBox2>
      </FlexBox>
    </Container>
  )
}
ReaderBlock.defaultProps = {
  name: "テスト",
  layout: "right",
}
ReaderBlock.propTypes = {
  post_title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  layout: PropTypes.string,
  bg: PropTypes.string.isRequired,
  anchor_link: PropTypes.string,
  post_url: PropTypes.string,
  publish_date: PropTypes.string,
}

export default ReaderBlock
